import { FC } from 'react';
import { SelectableRosterStar } from '../../roster';
import { cn } from '@wwe-portal/ui/lib/lib';

export const RosterItemStar: FC<{
  stats: {
    rate: number;
    level: 'B' | 'S' | 'G';
  } | null;
}> = ({ stats }) => {
  return stats ? (
    <SelectableRosterStar
      className={cn('absolute bottom-0 left-0 right-0 justify-center gap-0')}
      hollowStar={0}
      isStoreRevamp
      level={stats.level}
      maxRate={stats.rate}
      rate={stats.rate}
      starClassName={cn('', {
        'size-[22px] max-[376px]:size-[21px] max-[360px]:size-5 max-[320px]:size-[18px]':
          stats.rate === 1 || stats.rate === 2,
        'size-[18px] max-[376px]:size-4 max-[360px]:size-[15px] max-[320px]:size-[14px]':
          stats.rate === 3 || stats.rate === 4,
        'size-[15px] max-[376px]:size-[14px] max-[360px]:size-[13px] max-[320px]:size-[12px]':
          stats.rate === 5,
        'size-[35px] max-[376px]:size-[30px] max-[360px]:size-[28px] max-[320px]:size-[25px]':
          stats.rate === 6,
      })}
    />
  ) : null;
};
